import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { MatrixParams, getMatrix } from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

const STALE_TIME = 60 * 1000;
const GC_TIME = 5 * 60 * 1000;

// The read of one matrix, shared by the hook and by a file export, which
// takes the rows on screen from the cache
export const matrixQuery = (params: MatrixParams) => ({
  queryKey: queryKeys.productPlane.matrix(params),
  queryFn: () => getMatrix(params),
  staleTime: STALE_TIME,
});

/**
 * TanStack Query hook for the matrix of rows against columns over a selection
 * of products.
 *
 * The caller builds the request from the selection and the table's settings.
 * Uses `keepPreviousData` so the previous page stays visible while the next
 * one loads.
 */
export function useMatrix(params: MatrixParams, enabled = true) {
  return useQuery({
    ...matrixQuery(params),
    enabled,
    gcTime: GC_TIME,
    placeholderData: keepPreviousData,
  });
}
